import { Box } from 'reflexbox/styled-components';
import styled, { css } from 'styled-components';

export const SwitchBox = styled(Box)`
  margin: 0 0 25px 0;
  display: flex;
  align-items: center;

  ${(props) =>
    props.activeLink &&
    css`
      position: absolute;
      top: 14px;
      right: -6px;
      gap: 8px;
      scale: 0.7;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
      //visibility: hidden;
    `}

  ${(props) =>
    props.absolute &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      justify-content: space-between;
      width: 100%;
      padding: 15px;
      background: rgba(0, 0, 0, 0.5);
    `}

  ${(props) =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex};
    `}

  ${(props) =>
    props.reverse &&
    css`
      justify-content: space-between;
      flex-direction: row-reverse;
    `}
`;

export const SwitchTitle = styled(Box)`
  font-size: 16px;
  margin-right: 15px;

  ${(props) =>
    props.center &&
    css`
      display: flex;
      align-items: center;
      gap: 8px;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.showOptions &&
    css`
      font-size: 12px;
      color: #1bc3fe;
      cursor: pointer;
      text-transform: uppercase;
    `}

  ${(props) =>
    props.insideTikTokModal &&
    css`
      color: #fff;
    `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}
`;

export const SwitchBoxContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const SwitchLabel = styled.label`
  flex: none;
  position: relative;
  display: inline-block;
  width: 42px;
  height: 25px;

  ${(props) =>
    props.insideShop &&
    css`
      margin-left: auto;
      margin-right: 5px;
    `}

  ${(props) =>
    props.small &&
    css`
      width: 36px;
      height: 18px;
    `}

  ${(props) =>
    props.smallMenu &&
    css`
      width: 32px;
      height: 14px;
    `}

  ${(props) =>
    props.isRight &&
    css`
      position: relative;
      right: -10px;
    `}
`;

export const SwitchSpan = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--main-gray);
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 17px;
    width: 17px;
    left: 4px;
    bottom: 4px;
    background-color: var(--main-background);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${(props) =>
    props.small &&
    css`
      &:before {
        height: 17px;
        width: 17px;
        left: 4px;
        bottom: 4px;
      }
    `}

  ${(props) =>
    props.smaller &&
    css`
      &:before {
        height: 12px;
        width: 12px;
        left: 4px;
        bottom: 3px;
      }
    `}



  ${(props) =>
    props.product &&
    css`
      &:before {
        height: 12px;
        width: 12px;
        left: 4px;
        bottom: 3px;
      }
    `}


  ${(props) =>
    props.smallMenu &&
    css`
      &:before {
        left: 3px;
        bottom: 3px;
        height: 8px;
        width: 8px;
      }
    `}
`;

export const SwitchInput = styled.input`
  display: none;

  &:checked + ${SwitchSpan} {
    background-color: #2196f3;
  }

  &:focus + ${SwitchSpan} {
    box-shadow: 0 0 1px #2196f3;
  }

  &:checked + ${SwitchSpan}:before {
    transform: translateX(18px);
  }

  ${(props) =>
    props.bgGreen &&
    css`
      &:checked + ${SwitchSpan} {
        background-color: #17ce17;
      }
    `}

  ${(props) =>
    props.activeLink &&
    css`
      &:checked + ${SwitchSpan} {
        background-color: #17ce17;
      }
    `}


  ${(props) =>
    props.isSmallMenu &&
    css`
      display: block;
      position: relative;
      z-index: 1000;
      width: 100%;
      opacity: 0;
      cursor: pointer;
    `}
`;

export const ToggleLinkForm = styled(Box)`
  min-height: 20px;
`;

export const EditActionButtonBox = styled(Box)``;

export const EditActionButtonContent = styled(Box)`
  display: flex;

  ${(props) =>
    props.ctaButton &&
    css`
      justify-content: space-between;
      width: 100%;

      @media (max-width: 768px) {
        width: 100%;
      }
    `}
`;
